import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  rabbyWallet,
  rainbowWallet,
  walletConnectWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { configureChains, createConfig } from "wagmi";
import { SafeConnector } from "wagmi/connectors/safe";
import { infuraProvider } from "wagmi/providers/infura";
import { publicProvider } from "wagmi/providers/public";
import { supported } from "~/client/constants";
import type { IEnvironmentVariable } from "@sablier/v2-types";
import { connector as mocked } from "./mock";

const INFURA = (process.env.NEXT_PUBLIC_INFURA_ID ??
  "") satisfies IEnvironmentVariable;

const PROJECT_ID = (process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID ??
  "") satisfies IEnvironmentVariable;

const safe = new SafeConnector({
  chains: supported.map((chain) => chain.wagmi),
  options: {
    allowedDomains: [/gnosis-safe.io$/, /app.safe.global$/],
    debug: false,
  },
});

function configure(data: {
  first: number;
  isHostCypress: boolean;
  isHostSafe: boolean;
}) {
  const ordered = supported.sort((a, b) =>
    a.id === data.first ? -1 : b.id === data.first ? 1 : 0,
  );

  const { chains, publicClient } = configureChains(
    (ordered || []).map((chain) => chain.wagmi),
    [infuraProvider({ apiKey: INFURA }), publicProvider()],
  );

  const wallets = [
    coinbaseWallet({ appName: "Sablier V2", chains }),
    injectedWallet({ chains }),
    metaMaskWallet({ chains, shimDisconnect: true, projectId: PROJECT_ID }),
    rabbyWallet({ chains }),
    rainbowWallet({ chains, projectId: PROJECT_ID }),
    walletConnectWallet({
      chains,
      projectId: PROJECT_ID,
      options: {
        projectId: PROJECT_ID,
        qrModalOptions: {
          themeMode: "dark",
          themeVariables: {
            "--wcm-z-index": "2000000",
          },
        },
      },
    }),
    zerionWallet({ chains, projectId: PROJECT_ID }),
  ];

  const connectors = [
    safe,
    ...connectorsForWallets([{ groupName: "Recommended", wallets }])(),
  ];

  return {
    chains,
    config: createConfig({
      autoConnect: !data.isHostSafe,
      connectors: data.isHostCypress ? mocked : connectors,
      publicClient,
    }),
  };
}

export { configure, mocked, safe };
